import React from 'react';
import { CTAButton } from './CTAButton';
import { Flame, Clock, Shield } from 'lucide-react';
const tips = [{
  icon: Flame,
  text: 'Apagá la inflamación desde la primera comida.'
}, {
  icon: Clock,
  text: 'Plan de 21 días para la realidad argentina.'
}, {
  icon: Shield,
  text: 'Alivio inmediato (30 min) para crisis de dolor.'
}];
export function HeroSection() {
  const scrollToPlan = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('elegir-plan')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-marfil flex flex-col items-center px-4 pt-1 pb-3 min-h-[100svh] max-h-[844px] overflow-hidden" data-id="element-69">
      {/* Navbar */}
      <nav className="w-full max-w-md h-7 flex items-center justify-center" data-id="element-70">
        <span className="font-serif font-bold text-petroleo text-sm tracking-tight" data-id="element-71">
          Biología Femenina
        </span>
      </nav>

      <div className="w-full max-w-md flex flex-col flex-grow justify-center items-center text-center gap-1.5" data-id="element-72">
        {/* Overline */}
        <p className="text-[9px] font-bold uppercase tracking-[0.15em] text-salvia" data-id="element-73">
          Para mujeres cansadas de normalizar el dolor pélvico
        </p>

        {/* Headline */}
        <h1 className="font-serif font-bold text-petroleo text-[20px] leading-tight tracking-tight" data-id="element-74">
          Apagá el fuego de la inflamación en 21 días.
        </h1>

        {/* Subheadline */}
        <p className="font-sans text-gray-600 text-[12px] leading-snug px-1" data-id="element-75">
          Un protocolo biológico diseñado para la realidad argentina. Sin dietas
          imposibles ni pastillas extra: recuperá el control de tu cuerpo y
          volvé a sentirte vos.
        </p>

        {/* Mockup Image — compact */}
        <div onClick={scrollToPlan} className="cursor-pointer group my-1" data-id="element-76">
          <img src="https://cdn.magicpatterns.com/uploads/jqqzewP2m6WeZnAVKJhNk8/IMG_7845.png" alt="Protocolo Endo-Rescate" loading="eager" className="w-32 h-auto object-contain drop-shadow-xl group-hover:scale-105 transition-transform" data-id="element-77" />
        </div>

        {/* 3 Impact Tips — single line each */}
        <div className="w-full flex flex-col gap-1" data-id="element-78">
          {tips.map((tip, i) => <div key={i} className="flex items-center gap-1.5 text-left px-1" data-id="element-79">
              <tip.icon className="w-3 h-3 text-salvia flex-shrink-0" data-id="element-80" />
              <p className="text-gray-700 text-[11px] leading-tight" data-id="element-81">
                {tip.text}
              </p>
            </div>)}
        </div>

        {/* CTA — bright orange/coral for maximum contrast */}
        <div className="w-full mt-1.5 flex flex-col gap-1" data-id="element-82">
          <CTAButton text="Quiero mi Protocolo — $19.990" className="!text-base" data-id="element-83" />
          <p className="text-[10px] text-gray-500 font-medium" data-id="element-84">
            🔒 Pago seguro con Mercado Pago · Descarga instantánea
          </p>
        </div>
      </div>
    </section>;
}